import React from "react";
import ReactDOM from "react-dom";
import { createRoot } from 'react-dom/client';
import Table from "./agence/Table/Table";


const parallaxVisuelAgence = () =>{
	document.querySelector('.agence').addEventListener('scroll',(event) => {
		const doc = document.querySelector('.agence');
	
		scrollY = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0)
	
		if(window.innerWidth >= 600){

			const parallax = scrollY / 2;

			document.querySelector('.agence .introduction__visuel img').style.transform = `translateY(${parallax}px)`

		}
	
	
	});
}

if (document.querySelector("main.agence")) {

    const root = createRoot(document.getElementById("react-root"));
    const data = JSON.parse( document.querySelector("[data-agence]").getAttribute('data-agence') );

    root.render(
        <>
            <Table data={data}/>
        </>
    );


	parallaxVisuelAgence();

}


